import { memo } from 'react';
import { HStack, Stack, Text } from '@adc/parallax-component-library';
import {
  IconValidationInvalid,
  IconValidationNotValidated,
  IconValidationValid,
} from '@adc/parallax-icons';

import { buildTestId } from '~/utilities/buildTestId';
import i18n from '~/utilities/i18n';

type Props = {
  requirements: Requirement[];
  testID?: string;
};

export const PasswordRequirements = memo(({ requirements, testID }: Props) => (
  <Stack testID={testID}>
    {requirements.map(({ isInvalid, match, data }) => {
      const baseTestId = buildTestId({
        testID,
        suffix: ['requirement', String(data.key)],
      });

      return (
        <HStack alignItems="center" key={data.key} testID={baseTestId}>
          {isInvalid ? (
            <IconValidationInvalid
              color="$support.danger.surfaceOnColorAlt"
              testID={buildTestId({
                testID: baseTestId,
                suffix: ['invalid', 'icon'],
              })}
            />
          ) : match ? (
            <IconValidationValid
              color="$support.positive.default"
              testID={buildTestId({
                testID: baseTestId,
                suffix: ['valid', 'icon'],
              })}
            />
          ) : (
            <IconValidationNotValidated
              color="$neutral.40"
              testID={buildTestId({
                testID: baseTestId,
                suffix: ['not', 'validated', 'icon'],
              })}
            />
          )}
          <Text
            marginLeft="$2"
            testID={buildTestId({ testID: baseTestId, suffix: 'text' })}
            color={
              isInvalid ? '$support.danger.surfaceOnColorAlt' : '$neutral.60'
            }
            type="$bodySmall.default"
          >
            {i18n.t(
              // @ts-expect-error FIXME: need more predictable typing
              `Login.content.signInForm.formField.password.helpText.${data.key}`,
              { count: data.value },
            )}
          </Text>
        </HStack>
      );
    })}
  </Stack>
));

PasswordRequirements.displayName = 'PasswordRequirements';
